// @flow

import classNames from "classnames";
import React, { useRef, useState } from "react";
import YouTube from "react-youtube";

import iconBruSpinner from "@/images/icons/icon-bru-light.svg";
import iconPlay from "@/images/icons/icon-play.svg";

type Props = {
    id: string,
    aspectRatio?: string,
    autoplay?: boolean,
    placeholder?: String,
}

const YoutubeVideoPlayer = ({aspectRatio, autoplay, id, placeholder}: Props): React$Element<HTMLDivElement> => {
    const [loading, setLoading] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const player = useRef();

    const onLoaded = (event) => {
        player.current = event.target;

        setLoading(false);
    }

    const onClick = () => {
        if (!isPlaying) {
            player.current.playVideo()
        }
    }

    const onPause = () => setIsPlaying(false)

    const onPlay = () => setIsPlaying(true)

    return <div className="youtube-video-player">
        <YouTube
            videoId={id}
            onReady={onLoaded}
            onPause={onPause}
            onEnd={onPause}
            onPlay={onPlay}
            opts={{
                width: "100%",
                height: "100%",
                autoplay,
            }}
            style={{aspectRatio: aspectRatio ?? "16/9"}}
        />

        <div className="video-placeholder" onClick={onClick} style={{opacity: isPlaying ? "0" : "1", pointerEvents: isPlaying ? "none" : "all"}}>
            <img src={placeholder ?? `https://img.youtube.com/vi/${id}/maxresdefault.jpg`} />

            <div className={classNames("video-action", loading ? "loading" : "play")}>
                <img src={loading ? iconBruSpinner : iconPlay} />
            </div>
        </div>
    </div>
}


export default YoutubeVideoPlayer;
